export const globalAssets = {
  background_1920: require("../../assets/wc/videos/background_1920x1080_v2.webm"),
  insight_zone_logo: require("../../assets/wc/images/insight_zone_white.png"),
  of_logo: require("../../assets/wc/images/of_logo.svg"),
  sd_background_1920: require("../../assets/wc/videos/SD_background_1920x1080.webm"),
  sd_background_split: require("../../assets/wc/videos/SD_Background_2_split.webm"),
  sd_dfb_tv_logo: require("../../assets/sportdigital/images/DFB_TV_logo.png"),
};
